import api from "@/utils/http";

export * from './type'

/**
 功能：
 time: 2026/1/7 11:44
 **/
export function getExpenseConfig() {
    return api.get('/admin/expense/getSetConfig')
}

/**
 功能：
 time: 2026/1/7 11:44
 **/
export function getExpenseList(data) {
    return api.post('/admin/expense/getList', data)
}
export function getExpensePartnerList(data) {
    return api.post('/admin/expense/getPartnerList', data)
}

/**
 功能：
 time: 2026/1/7 12:02
 **/
export function saveExpense(data) {
    return api.post('/admin/expense/eSave', data)
}

/**
 功能：
 time: 2026/1/7 12:05
 **/
export function getExpenseDetail(id) {
    return api.post('/admin/expense/getDetail', {id })
}

/**
 功能：
 time: 2026/1/7 14:11
 **/
export function deleteExpense(id) {
    return api.post('/admin/expense/del', {id})
}

/**
 功能：
 time: 2025/12/27 11:01
 **/
export function examineExpense(data) {
    return api.post('/admin/expense/examineSave', data)
}

/**
 功能：
 time: 2025/12/27 11:47
 **/
export function payExpense(data) {
    return api.post('/admin/expense/paySave', data)
}